import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=12f3364e&scoped=true&"
import script from "./content2.vue?vue&type=script&lang=js&"
export * from "./content2.vue?vue&type=script&lang=js&"
import style0 from "./content2.vue?vue&type=style&index=0&id=12f3364e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3364e",
  null
  
)

export default component.exports